import React, { Component, Components } from 'react';
import { withStyles } from '@material-ui/core/styles';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom'
import { bindActionCreators } from 'redux';
import RGL, { WidthProvider } from 'react-grid-layout';
import _ from 'lodash';
import { Card, CardContent, AppBar, Typography, Divider, Paper, Button, Grid } from '@material-ui/core';
import * as Actions from './../store/actions';
import Widget from '../widgets/Widget';
import 'react-grid-layout/css/styles.css';
import 'react-resizable/css/styles.css';

const styles = theme => ({
});
const ReactGridLayout = WidthProvider(RGL);

class NewUserDashboard extends Component {
    state = {
        layout: [],
    }

    constructor(props) {
        super(props);
    }

    getCourseButton = () => {
        const course = this.props.auth.user.all_roles.filter(r => r.role_id === 4)[0].link_info.ActiveCourses.filter(c => c.finished === 0)[0]
        return (
            <Button
                onClick={() => this.props.history.push('/course-dashboard/' + course.company_calendar_course_id + '/' + course.Unscheduled)}
                variant={'contained'}
                color={'primary'}
            >
                Course
            </Button>
        )
    }

    render() {
        const courseButton = this.getCourseButton()

        return (
            <div>
                <Typography variant="h2" className={'text-center'}>Welcome to University</Typography>

                <Typography variant="h6" className={'text-center'}>Please complete this intro course</Typography>

                <div className={'text-center'}>
                    {courseButton}
                </div>

            </div>



        );
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        // saveLayout: Actions.saveLayout
    }, dispatch);
}

function mapStateToProps({ dashboardApp, auth }) {
    return {
        // dashboard_layout:         dashboardApp.dashboard.dashboard_layout,
        // grid_layout:              dashboardApp.dashboard.grid_layout,
        auth: auth
    }
}

export default withStyles(styles, { withTheme: true })(withRouter(connect(mapStateToProps, mapDispatchToProps)(NewUserDashboard)));


// WEBPACK FOOTER //
// src/main/content/dashboard/components/NewUserDashboard.js